// App.tsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthRouter, RouterList } from "./router/Router";
import 'react-toastify/dist/ReactToastify.css';
import "./App.scss";
import { useAppSelector } from "./redux/hooks";
import { AuthProvider } from "./context/AuthProvider";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { colour } from "./constant/colours";
import CustomizedSnackbars from "./components/Elements/Toaster/Toaster";
import Layout from "./components/Layout/Layout";
import Loader from "./components/Loader/Loader";
import { ToastContainer } from 'react-toastify';
import { TourProvider } from "./context/TourContext";

const theme = createTheme({
  typography: {
    fontFamily: [
      'Source Sans Pro',
      'sans-serif',
    ].join(','),
  },
  palette: {
    primary: {
      main: colour.Primary,
      light: colour.grayDark
    },
    secondary: {
      main: colour.Secondary,
      contrastText: colour.white,
      light: colour.lightPink
    },
    text: {
      secondary: colour.text
    }
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: colour.white
        }
      }
    }
  }
});

const App: React.FC = () => {

  const { token = "", typeofToaster, messageofToaster } = useAppSelector((state: any) => state.auth);
  const { isConfigLoader, configMessage, configType } = useAppSelector((state: any) => state.config);
  const { estimateType, estimateMessage } = useAppSelector((state: any) => state.estimate);

  if (!token) {
    <Navigate to={"/"} />
  }
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <TourProvider>
          {(typeofToaster || configType || estimateType) && <CustomizedSnackbars type={typeofToaster || configType || estimateType} message={messageofToaster || configMessage || estimateMessage} />}
          {isConfigLoader && <Loader />}
          {token ? (
            <Layout>
              <Routes>
                {AuthRouter.map((subelm: any, idx: number) => (
                  <Route key={idx} path={subelm.subpath} Component={subelm.subelement} />
                ))}
                <Route
                  path="/*"
                  element={
                    // Redirect to a specific path after successful login
                    <Navigate to={AuthRouter[0].subpath} replace />
                  }
                />
              </Routes>
            </Layout>
          ) : (
            <Routes>
              {RouterList.map((elm: any, idx: number) => (
                <Route key={idx} path={elm.path} Component={elm.element} />
              ))}
              <Route
                path="/*"
                element={
                  // Redirect to a specific path after successful login
                  <Navigate to="/" replace />
                }
              />
            </Routes>)}
          <ToastContainer   position="top-center" />
          {/* Catch-all route for not-found pages */}
        </TourProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
